import React, { useState, useEffect } from 'react';
import { healthAPI } from '../api';

function VPSMonitor() {
  const [vpsHealth, setVpsHealth] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchVPSHealth();
    const interval = setInterval(fetchVPSHealth, 60000); // Refresh every 60 seconds
    return () => clearInterval(interval);
  }, []);

  const fetchVPSHealth = async () => {
    try {
      const response = await healthAPI.checkVPSHealth();
      setVpsHealth(response.data);
      setError('');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch VPS health');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading VPS information...</div>;
  }

  return (
    <div className="component-container">
      <div className="component-header">
        <h2>VPS Resource Monitor</h2>
        <button className="btn-primary" onClick={fetchVPSHealth}>
          Refresh
        </button>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      {vpsHealth && (
        <>
          <div className="vps-summary">
            <div className="info-grid">
              <div className="info-card">
                <h3>VPS Information</h3>
                <div className="info-items">
                  <div className="info-item">
                    <span className="label">Provider:</span>
                    <span className="value">Hetzner Cloud CPX41</span>
                  </div>
                  <div className="info-item">
                    <span className="label">IP Address:</span>
                    <span className="value">178.156.128.52</span>
                  </div>
                  <div className="info-item">
                    <span className="label">vCPU:</span>
                    <span className="value">8 cores</span>
                  </div>
                  <div className="info-item">
                    <span className="label">RAM:</span>
                    <span className="value">16 GB</span>
                  </div>
                  <div className="info-item">
                    <span className="label">Disk:</span>
                    <span className="value">160 GB SSD</span>
                  </div>
                </div>
              </div>

              <div className="info-card">
                <h3>Overall Health</h3>
                <div className="health-stats">
                  <div className="stat">
                    <p className="stat-label">Healthy Applications</p>
                    <p className="stat-value">
                      {vpsHealth.summary.healthy}/{vpsHealth.summary.total}
                    </p>
                  </div>
                  <div className="stat">
                    <p className="stat-label">Uptime</p>
                    <p className="stat-value">{vpsHealth.summary.uptime}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="applications-section">
            <h3>Deployed Applications</h3>
            <div className="apps-grid">
              {vpsHealth.checks.map((check) => {
                const isHealthy = check.status === 'healthy';
                return (
                  <div
                    key={check.domain}
                    className={`app-card ${isHealthy ? 'healthy' : 'unhealthy'}`}
                  >
                    <div className="app-status">
                      <span className={`status-dot ${check.status}`}></span>
                      <h4>{check.domain}</h4>
                    </div>
                    <div className="app-details">
                      <p>
                        Status: <strong>{check.status.toUpperCase()}</strong>
                      </p>
                      {check.responseTime && (
                        <p>Response: <strong>{check.responseTime}ms</strong></p>
                      )}
                      {check.code && (
                        <p>HTTP: <strong>{check.code}</strong></p>
                      )}
                      {!isHealthy && check.error && (
                        <p className="error-text">{check.error}</p>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="component-footer">
            <p className="text-small">
              Last checked: {new Date().toLocaleString()} • Auto-refreshes every 60 seconds
            </p>
          </div>
        </>
      )}
    </div>
  );
}

export default VPSMonitor;
